<template>
  <div>
    <b-modal
      id="detail-sppd-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail SPPD"
    >
      <div class="icons-print">
        <span v-print="printObj" class="material-symbols-outlined">print</span>
      </div>
      <b-row id="print-data">
        <div class="title">
          <h3>Pengajuan SPPD BPRS HIK Parahyangan</h3>
          <h3>{{ time }}</h3>
        </div>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama Karyawan</span></th>
                <td>{{ result.employee ? result.employee.fullName : "-" }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Tgl Awal</span></th>
                <td>{{ result.startDate }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Tgl Akhir</span></th>
                <td>{{ result.endDate }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Menginap</span></th>
                <td><span class="badge text-capitalize badge-pill" :class="result.stay ? 'badge-light-success' : 'badge-light-danger'">{{ result.stay ? 'Ya' : 'Tidak' }}</span></td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Jenis Transport</span></th>
                <td>{{ result.transportType ? result.transportType.paramListDesc : result.transportType }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Status</span></th>
                <td>{{ result.statusApproval }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Tujuan</span></th>
                <td>{{ result.purpose }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { BCol, BAvatar, BRow } from "bootstrap-vue";
import utility from '../../libs/utility'

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
  data() {
    return {
      printObj: {
        id: 'print-data'
      },
      time: ''
    }
  },
  watch: {
    result: (value) => {
      window.console.log(value);
    }
  },
  mounted() {
     let date = new Date();
     this.time = utility.FormatDate(date);
  }
};
</script>

<style lang="scss" >
  .icons-print {
    span {
      color: green;
      cursor: pointer;
    }
  }
  .title {
    position: relative;
    margin-left: 12px;
    margin-top: 8px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-right: 12px;
    h3 {
      font-size: 15px;
    }
  }
</style>
